<template>
  <v-container fluid v-if="tiene_empresa">
    <v-data-table :headers="headerTable1" :items="items">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("products-table-top-t1") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nuevoProducto()">
            {{ $t("products-table-top-btn1") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon class="mr-2" @click="editarProducto(item)" :disabled="$store.state.usuario.rol == 'Solo Vista'">
          fa-solid fa-pen-to-square
        </v-icon>
      </template>

      <template v-slot:[`item.activo`]="{ item }">
        <span>{{ conversion(item.activo) }}</span>
      </template>
      <template v-slot:[`item.exento`]="{ item }">
        <span>{{ conversion(item.exento) }}</span>
      </template>
      <template v-slot:[`item.no_sujeto`]="{ item }">
        <span>{{ conversion(item.no_sujeto) }}</span>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="800" persistent>
      <v-card>
        <v-card-title>{{ $t("products-dialog-t1") }}</v-card-title>
        <v-card-text>
          <v-row class="pt-3">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="codigo_producto"
                :label="$t('products-dialog-input-label1')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="codigo_barra"
                :label="$t('products-dialog-input-label2')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="nombre"
                :label="$t('products-dialog-input-label3')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="modelo"
                :label="$t('products-dialog-input-label5')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
              v-model="marca"
              :items="['Marca 1', 'Marca 2', 'Marca 3']"
              :label="$t('products-dialog-input-label6')"
              outlined
              dense
              hide-details  
            ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
              v-model="unidad"
              :items="['Unidad 1', 'Unidad 2', 'Unidad 3']"
              :label="$t('products-dialog-input-label7')"
              outlined
              dense
              hide-details  
            ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
              v-model="grupo"
              :items="['Grupo 1', 'Grupo 2', 'Grupo 3']"
              :label="$t('products-dialog-input-label8')"
              outlined
              dense
              hide-details  
            ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
              v-model="sub_grupo"
              :items="[]"
              :label="$t('products-dialog-input-label9')"
              outlined
              dense
              hide-details  
            ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="precio"
                :label="$t('products-dialog-input-label4')"
                prefix="$"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-row class="pt-3">
              <v-checkbox
                v-model="activo"
                :label="$t('products-dialog-checkbox1')"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="exento"
                :label="$t('products-dialog-checkbox2')"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="no_sujeto"
                :label="$t('products-dialog-checkbox3')"
                dense
              ></v-checkbox>
            </v-row>
            </v-col>
          </v-row>    
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="crearProducto()"
            v-if="flag_new_edit == 1"
            :disabled="$store.state.usuario.rol == 'Solo Vista'"
            >{{ $t("btn-save") }}</v-btn
          >
          <v-btn
            color="primary"
            @click="actualizarProducto()"
            v-if="flag_new_edit == 2" 
            :disabled="$store.state.usuario.rol == 'Solo Vista'"
            >{{ $t("btn-update") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog()">{{ $t("btn-close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="8000"
      color="blue"
      multi-line
      elevation="24"
      outlined
      top
      right
    >
      <v-icon>{{ icon_snackbar }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>
  
<script>
import axios from "axios";
export default {
  data: () => ({
    dialog: false,
    snackbar: false,
    icon_snackbar: "fa-solid fa-circle-info",
    snackbar_text: "...",
    id_producto: 0,
    id_empresa: 0,
    codigo_barra: "",
    codigo_producto: "",
    nombre: "",
    activo: false,
    exento: false,
    no_sujeto: false,
    precio: "",
    items: [],
    flag_new_edit: 1,
    modelo: "",
    marca: "",
    unidad: "",
    grupo: "",
    sub_grupo: "",
  }),
  created() {
    //
  },
  computed: {
    tiene_empresa() {
      if (this.$store.state.emp) {
        this.listarProductos();
        return true;
      }
    },
    headerTable1() {
      return [
        { text: this.$t("products-table-header-t1"), value: "cod_producto" },
        { text: this.$t("products-table-header-t2"), value: "cod_barra" },
        { text: this.$t("products-table-header-t3"), value: "nom_producto" },
        { text: this.$t("products-table-header-t4"), value: "activo" },
        { text: this.$t("products-table-header-t5"), value: "exento" },
        { text: this.$t("products-table-header-t6"), value: "no_sujeto" },
        { text: this.$t("products-table-header-t7"), value: "precio" },
        {
          text: this.$t("products-table-header-t8"),
          value: "action_edit",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    conversion(item) {
      if (item) {
        return "Activo";
      } else {
        return "Inactivo";
      }
    },
    listarProductos() {
      if (this.$store.state.emp.id_empresa != undefined)
        axios
          .get("api/Productos/Listar/" + this.$store.state.emp.id_empresa)
          .then((response) => {
            this.items = response.data;
          });
    },
    nuevoProducto() {
      this.flag_new_edit = 1;
      this.dialog = true;
    },
    crearProducto() {
      axios
        .post("api/Productos/Crear", {
          id_empresa: this.$store.state.emp.id_empresa,
          activo: this.activo,
          cod_barra: this.codigo_barra,
          cod_producto: this.codigo_producto,
          exento: this.exento,
          nom_producto: this.nombre,
          no_sujeto: this.no_sujeto,
          precio: this.precio,
        })
        .then(() => {
          this.snackbar_text = this.$t('products-snackbar-t1');
          this.snackbar = true;

          this.cerrarDialog();
          this.listarProductos();
        })
        .catch(() => {
          this.snackbar_text = this.$t('products-snackbar-t2');
          this.snackbar = true;
        });
    },
    editarProducto(item) {
      //console.log(item);
      this.id_producto = item.id_producto;
      this.id_empresa = item.id_empresa;
      this.activo = item.activo;
      this.codigo_barra = item.cod_barra;
      this.codigo_producto = item.cod_producto;
      this.exento = item.exento;
      this.no_sujeto = item.no_sujeto;
      this.nombre = item.nom_producto;
      this.precio = item.precio;

      this.flag_new_edit = 2;
      this.dialog = true;
    },
    actualizarProducto() {
      axios
        .put("api/Productos/Actualizar", {
          id_producto: this.id_producto,
          id_empresa: this.id_empresa,
          activo: this.activo,
          cod_barra: this.codigo_barra,
          cod_producto: this.codigo_producto,
          exento: this.exento,
          nom_producto: this.nombre,
          no_sujeto: this.no_sujeto,
          precio: this.precio,
        })
        .then(() => {
          this.snackbar_text = this.$t('products-snackbar-t3');;
          this.snackbar = true;

          this.cerrarDialog();
          this.listarProductos();
        })
        .catch(() => {
          this.snackbar_text = this.$t('products-snackbar-t4');
          this.snackbar = true;
        });
    },
    cerrarDialog() {
      this.dialog = false;

      this.limpiar();
    },
    limpiar() {
      this.id_producto = 0;
      this.id_empresa = 0;
      this.codigo_barra = "";
      this.activo = "";
      this.codigo_producto = "";
      this.nombre = "";
      this.exento = false;
      this.no_sujeto = false;
      this.precio = "";
    },
  },
};
</script>